import { render, staticRenderFns } from "./BasePopUp.vue?vue&type=template&id=5b08a7f2&scoped=true&"
import script from "./BasePopUp.vue?vue&type=script&lang=js&"
export * from "./BasePopUp.vue?vue&type=script&lang=js&"
import style0 from "./BasePopUp.vue?vue&type=style&index=0&id=5b08a7f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b08a7f2",
  null
  
)

export default component.exports